<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="clients" class="clients">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <div class="clients-slider swiper">
      <div class="swiper-wrapper align-items-center">
        {#each blocklist(block, 'slides') as item}
        <div class="swiper-slide">
          <img src="{image(item, 'logo', [null, 200])}" height="200" class="img-fluid" alt="">
        </div>
        {/each}
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>

</section>
